import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
// Components
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ComponentLocator from './components/ComponentLocator';
import ComponentSearchResults from './components/ComponentSearchResults';
import SupplierRegistration from './components/SupplierRegistration';
import Login from './components/Login';
import Register from './components/Register';
import LoggedOutRoute from './components/LoggedOutRoute';
import UserSubscriptions from './components/UserSubscriptions';
import BetaComponentLocator from './components/BetaComponentLocator';
import BetaComponentSearchResults from './components/BetaComponentSearchResults';
import UploadPricing from './components/UploadPricing';
import UploadMpns from './components/UploadMpns';

function Layout({ children }) {
  const location = useLocation();
  const dontShowHeaderAndFooter = location.pathname?.includes("raw");
  return (
    <div className="App d-flex flex-column min-vh-100" style={{ maxWidth: '90%', margin: 'auto', backgroundColor: '#fff' }}>
      {!dontShowHeaderAndFooter && <Header />}
      <main className="flex-grow-1">{children}</main>
      {!dontShowHeaderAndFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Layout>
            <Routes>
              <Route path="/" element={<ComponentLocator />} />
              <Route path="/search" element={<ComponentSearchResults />} />
              <Route path="/subscriptions" element={<UserSubscriptions />} />
              <Route path="/supplier/register" element={<SupplierRegistration />} />
              <Route path="/beta" element={<BetaComponentLocator />} />
              <Route path="/beta-search" element={<BetaComponentSearchResults />} />
              <Route path="/upload-pricing" element={<UploadPricing />} />
              <Route path="/upload-pricing-raw" element={<UploadPricing />} />
              <Route path="/upload-mpns" element={<UploadMpns />} />
              <Route path="/upload-mpns-raw" element={<UploadMpns />} />
              <Route path="/login" element={<LoggedOutRoute><Login /></LoggedOutRoute>} />
              <Route path="/register" element={<LoggedOutRoute><Register /></LoggedOutRoute>} />
            </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
}

export default App;
